import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { outstandingBillEntry } = stateEnum;

const initialState = {
    detailParams: {},         
    isNewEntry: false,        
};

const outstandingBillEntrySlice = createSlice({
    name: outstandingBillEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload;
        },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
});

export const {
    setNewEntryMode,
    setDetailParams,
    resetDetailParams,
} = outstandingBillEntrySlice.actions;

export default outstandingBillEntrySlice.reducer;
